<template>
  <span>
    <span v-if="!sendSuccess">
      <b-row class="justify-content-md-center my-4 text-center">
        <b-col cols="12">
          <p>
            Les fichiers ont été générés. Si vous quittez maintenant, vous
            pouvez les retrouver sur la page des reçus fiscaux.
          </p>
          <p>
            Les reçus fiscaux seront envoyés depuis l'adresse suivante :
            <b>{{ user.email }}</b>
          </p>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center text-center">
        <b-col lg="4" md="5" sm="6" xl="3">
          <b-button
            variant="success"
            @click="testEmail()"
            v-b-tooltip.hover
            title="Un reçu fiscal au hasard sera envoyé dans votre boite mail"
            >Effectuer un test</b-button
          >
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center text-center mt-2">
        <b-button
          v-if="!sendSuccess"
          class="my-2"
          variant="danger"
          @click="sendAllRecus()"
        >
          Envoi de tous les reçus fiscaux
        </b-button>
      </b-row>
    </span>
    <b-row v-else class="justify-content-md-center text-center">
      <h2 class="my-2 text-primary">
        Bravo!!!! L'équipe de l'application souhaite une bonne déclaration à vos
        adhérents
      </h2>
    </b-row>
  </span>
</template>

<script>
import ApiService from "../../service/apiService";
import toastService from "../../service/toastService";
import AuthService from "@/service/authService";

export default {
  props: { year: { type: String, required: false } },
  name: "ExportEtape4Envoi",
  data() {
    return {
      sendRecuParams: { year: this.year },
      testSuccess: false,
      sendSuccess: false,
      user: null,
    };
  },
  mounted: async function () {
    this.user = await AuthService.getUser();
  },
  methods: {
    async testEmail() {
      var res = await ApiService.recuFiscal.testEmail(this.sendRecuParams);
      if (res.data) {
        this.testSuccess = res.data.success;
        toastService.displaySuccessToast(res.data.message);
      }
    },
    async sendAllRecus() {
      if (this.testSuccess) {
        var res = await ApiService.recuFiscal.sendRecus(this.sendRecuParams);
        if (res.data) {
          toastService.displaySuccessToast(res.data.message);
          this.testSuccess = false;
          this.sendSuccess = true;
        }
      } else {
        toastService.displayErrorToast("Vous devez d'abord passer le test ;-)");
      }
    },
  },
  watch: {
    year(val) {
      this.sendRecuParams.year = val;
    },
  },
};
</script>

<style></style>
